import { useEffect, useState } from 'react';
import { useAdvertiserAuthStore } from '../store/advertiserAuthStore';

export function useAdvertiserLogin() {
  const setSession = useAdvertiserAuthStore((s) => s.setSession);
  const [isPending, setIsPending] = useState(false);

  const login = async (email, password) => {
    setIsPending(true);
    try {
      const res = await fetch('/.netlify/functions/advertiser-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Login failed');
      setSession(data.token, data.advertiser);
      return data.advertiser;
    } finally {
      setIsPending(false);
    }
  };

  return { login, isPending };
}

export function useAdvertiserSignup() {
  const [isPending, setIsPending] = useState(false);
  const signup = async (payload) => {
    setIsPending(true);
    try {
      const res = await fetch('/.netlify/functions/advertiser-signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Signup failed');
      return data;
    } finally {
      setIsPending(false);
    }
  };
  return { signup, isPending };
}

// Verifies the stored token is still valid whenever an /ads/* page loads,
// and refreshes the advertiser record in case status changed since signup.
export function useVerifyAdvertiserSession() {
  const { token, setSession, clearSession } = useAdvertiserAuthStore();
  const [isChecking, setIsChecking] = useState(!!token);

  useEffect(() => {
    if (!token) { setIsChecking(false); return; }
    fetch('/.netlify/functions/advertiser-verify-session', { headers: { 'x-advertiser-token': token } })
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((data) => setSession(token, data.advertiser))
      .catch(() => clearSession())
      .finally(() => setIsChecking(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const advertiser = useAdvertiserAuthStore((s) => s.advertiser);
  return { advertiser, isChecking };
}